<template>
  <div class="c-app flex-row align-items-center">
    <div v-if="submitted" class="loader">
      <CSpinner
        style="width:3rem;height:3rem;"
        color="primary"
        grow
      />
    </div>
    
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="username email"
                    name="email"
                    v-model="form.email"
                    v-validate="{required: true, min: 3, email: true}"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <div v-if="errors" class="error_msg">
                    {{errors.first('email')}}
                  </div>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    name="password"
                    v-model="form.password"
                     v-validate="{required: true}"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <div v-if="errors" class="error_msg">
                    {{errors.first('password')}}
                  </div>
                  <CRow class="mt-3">
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" @click="Login">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <router-link to="/forgot-password">
                        Forgot password?
                      </router-link>
                      <router-link to="/register">
                        <CButton color="link" class="d-lg-none">Register now!</CButton>
                      </router-link>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {handleResponseException, handleUserLoginLogOutAction} from "@/helpers/Helpers";
import {noTokenRequest} from "@/config/httpCommon"
import Store from "../../store";

export default {
  name: 'Login',
  data(){
    return{
      form:{
        email: '',
        password: '',
      },
      submitted: false,
    }
  },
  methods: {
    async Login(){
      let valid = await this.$validator.validate();
      if(valid){
        this.submitted = true;
        let login_data = {
          email: this.form.email,
          password: this.form.password,
        }
       await noTokenRequest.post("login", login_data).then(async successResponse => {
         let response_data = successResponse.data;
         if(response_data.success) {
           await handleUserLoginLogOutAction('login', response_data.result);
         } else {
           this.showServerErrors(successResponse)
         }
         this.submitted = false;
        }).catch(error => {
         this.submitted = false;
          handleResponseException(error)
        });
      }
    }
  }
}
</script>
<style scoped>
    .form-group {
      margin: 1rem 0 0 0;
    }
    .input-group-prepend {
      background-color: transparent;
      padding: 0;
      color: #fff;
      padding-top: 0;
    }
</style>
